import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import * as CONSTANTS from "../CONSTANTS";
import { Link } from 'react-router-dom';
import ModalItem from '../Components/ModalItem';
import { toast } from 'react-toastify';

function UserList() {

    const [listOfUser, setListOfUser]                                     = useState([]);
    const [showModal, setShowModal]                                       = useState(false);
    const {user}                                                          = useSelector((state) => state.auth);

    const [isLoading, setIsLoading]                                       = useState(false);

    const [formData, setFormData] = useState({
        name: "",
        surname: "",
        email: "",
        phone: "",
        dateOfBirth: "",
        password: "PASSWORD1",
        subscribe: true,
      });

    useEffect(() => {
        collectHandleList();
    },[])

    const collectHandleList = async () => {
        try{

            const response = await axios.get(CONSTANTS.API_URL +"users/", {
                headers: {
                    token: "Bearer " + user.accessToken
                }
            });
            
            setListOfUser(response.data);
        }catch(err){
            console.log(err);
        }
    }

    const onChange = (e) => {
      const { name, value, type, checked } = e.target;
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    };

    const onSubmit = async (e) => {
      e.preventDefault();
      
      try{
         
          const response = await axios.post(CONSTANTS.API_URL + "auth/register/", formData);
          console.log(response);
          if(response.status === 200){
            toast.success("User has been created.");
            setFormData({
                  name: "",
                  surname: "",
                  email: "",
                  phone: "",
                  dateOfBirth: "",
                  password: "PASSWORD1",
                  subscribe: true,
                });
          }
      }catch(err){
        toast.error("Something went wrong, please try again later.");
        console.log(err);
      }

    };
    
  return (
    <div className="card">
      <div className="card-body">
        <h3 className="inner-part">Users List</h3>
         <div className="content-row-intro">
            <button className="btn btn-primary" onClick={() => setShowModal(true)}>
              Create +
            </button>
          </div>
           <ModalItem 
                    show={showModal} 
                    onClose={() => setShowModal(false)} 
                    title="Create Annisite"
                  >
                    <div className="body-content-part">
                       <form onSubmit={onSubmit}>
                        <div className="mb-3">
                          <label>Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={formData.name}
                            onChange={onChange}
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label>Surname</label>
                          <input
                            type="text"
                            className="form-control"
                            name="surname"
                            value={formData.surname}
                            onChange={onChange}
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label>Email</label>
                          <input
                            type="email"
                            className="form-control"
                            name="email"
                            value={formData.email}
                            onChange={onChange}
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label>Phone</label>
                          <input
                            type="tel"
                            className="form-control"
                            name="phone"
                            value={formData.phone}
                            onChange={onChange}
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label>Date of Birth</label>
                          <input
                            type="date"
                            className="form-control"
                            name="dateOfBirth"
                            value={formData.dateOfBirth}
                            onChange={onChange}
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label>Password</label>
                          <input
                            type="text"
                            className="form-control"
                            name="password"
                            value={formData.password}
                            onChange={onChange}
                            required
                          />
                          <div className="small">7 Characters or more</div>
                        </div>

                        <div className="form-check mb-3">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="subscribe"
                            checked={formData.subscribe}
                            onChange={onChange}
                            id="subscribeCheck"
                          />
                          <label className="form-check-label" htmlFor="subscribeCheck">
                            Subscribe to newsletter
                          </label>
                        </div>

                        <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
                          {isLoading ? "Registering..." : "Register"}
                        </button>
                      </form>
                    </div>
           </ModalItem>
            {
            listOfUser.length > 0 && (
              <div className="row-table-content">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>NO</th>
                        <th>Name</th>
                        <th>Surname</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Date of Birth</th>
                        <th>Role</th>
                        <th>#</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                          listOfUser.map((item, index) => {
                            return <tr key={item._id}>
                                    <td> {index + 1})</td>
                                    <td>{item.name}</td>
                                    <td>{item.surname}</td>
                                    <td>{item.email}</td>
                                    <td>{item.phone}</td>
                                    <td>{item.dateOfBirth}</td>
                                    <td>{item.role}</td>   
                                    <td>
                                      <Link to={'/user-details/' + item._id} className="btn btn-primary"> View
                                      </Link>
                                    </td>                                
                                  </tr>
                          })
                        }
                    </tbody>
                  </table>
              </div>
            )
          }
      </div>
    </div>
  )
}

export default UserList